<template>
  <div class="home">
<Navigation/>
    <div class="section bg-primary-3">
    <div class="container text-center">
      <h1>Open House Promos</h1>
      <div class="text-large">Make potential clients feel special.</div>
    </div>
  </div>
<Printables Category="open-house-promos" />


  </div>

</template>

<script>
import Navigation from "@/components/Navigation.vue"
import Printables from "@/components/PrintableCollection.vue"

export default {
  name: "home",
  components: {
    Navigation,
    Printables
  }
};
</script>
